import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Plan from './pages/Plan/Plan';
import Blog from './pages/Blog/Blog';
import BlogDetail from './pages/Blog/BlogDetail';
import UserList from './pages/Home/UserList';
import UserDetails from './pages/Home/UserDetails';
import Video from './pages/Video/Video';
import Contact from './pages/Contact/Contact';
import Faq from './pages/Faq/Faq';
import PayNow from './pages/PrivacyPolicy/PayNow';
import CheckStatus from './components/CheckStatus';

// Custom Pages

import BusinessPartnersServices from './pages/CustomPages/business-partner-services';
import BuySellBusinessServices from './pages/CustomPages/business-for-sale-buy';
import SkilledEmployeeHiringServices from './pages/CustomPages/skilled-employee-services';
import ThirdPartyBusinessServices from './pages/CustomPages/third-party-business-services';


import Newsletter from './pages/PrivacyPolicy/Newsletter';
import Privacypolicy from './pages/PrivacyPolicy/Privacypolicy';
import TeamMember from './pages/PrivacyPolicy/TeamMember';
import Termscondition from './pages/PrivacyPolicy/Termscondition';
import RefundPolicy from './pages/PrivacyPolicy/RefundPolicy';
import Register from './pages/Auth/Register';
import UserDashboard from './pages/User/Dashboard'; // Add this import
import ProtectedRoute from './components/ProtectedRoute';
import ServiceList from './pages/Services/ServiceList';
import ServiceDetail from './pages/Services/ServiceDetail';
import GlobalSeoInjector from './components/common/GlobalSeoInjector';
import ScrollToTop from './components/common/ScrollToTop';
import LoadingScreen from './components/common/LoadingScreen';
import NotFound from './pages/NotFound';
import './styles.css';

// Admin section is lazy-loaded as its own bundle. None of this - including
// the TinyMCE editor pulled in by ServiceManagement/BlogManagement, and all
// of Ant Design's Table/Tabs/Form components used across these screens -
// used to ship to public visitors who never touch /admin. It was all
// bundled into the same main.js as the homepage.
const AdminLayout = lazy(() => import('./components/layouts/AdminLayout'));
const AdminDashboard = lazy(() => import('./pages/Admin/Dashboard'));
const UserManagement = lazy(() => import('./pages/Admin/UserManagement'));
const UserSuspending = lazy(() => import('./pages/Admin/UserSuspending'));
const UserPendingManagement = lazy(() => import('./pages/Admin/UserPendingManagement'));
const PlanManagement = lazy(() => import('./pages/Admin/PlanManagement'));
const ContentManagement = lazy(() => import('./pages/Admin/ContentManagement'));
const CategoryManagement = lazy(() => import('./pages/Admin/CategoryManagement'));
const HomeManagement = lazy(() => import('./pages/Admin/HomeManagement'));
const AboutManagement = lazy(() => import('./pages/Admin/AboutManagement'));
const SubscriberManagement = lazy(() => import('./pages/Admin/SubscriberManagement'));
const CareerManagement = lazy(() => import('./pages/Admin/CareerManagement'));
const SubscribedUserManagement = lazy(() => import('./pages/Admin/SubscribedUserManagement'));
const AdminEnqueries = lazy(() => import('./pages/Admin/AdminEnqueries'));
const PartnersEnquiries = lazy(() => import('./pages/Admin/EnquiryTypes/PartnersEnquiries'));
const ServicesEnquiries = lazy(() => import('./pages/Admin/EnquiryTypes/ServicesEnquiries'));
const SkilledEnquiries = lazy(() => import('./pages/Admin/EnquiryTypes/SkilledEnquiries'));
const FranchiseeEnquiries = lazy(() => import('./pages/Admin/EnquiryTypes/FranchiseeEnquiries'));
const BusinessEnquiries = lazy(() => import('./pages/Admin/EnquiryTypes/BusinessEnquiries'));
const ThirdPartyEnquiries = lazy(() => import('./pages/Admin/EnquiryTypes/ThirdPartyEnquiries'));
const ServiceManagement = lazy(() => import('./pages/Admin/ServiceManagement'));
const BlogManagement = lazy(() => import('./pages/Admin/BlogManagement'));
const BlogTaxonomy = lazy(() => import('./pages/Admin/BlogTaxonomy'));
const SeoSettings = lazy(() => import('./pages/Admin/SeoSettings'));
const RedirectManager = lazy(() => import('./pages/Admin/RedirectManager'));

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <GlobalSeoInjector />
      <Suspense fallback={<LoadingScreen />}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
          
          
           <Route path="/business-partner-services" element={<BusinessPartnersServices />} />
           <Route path="/business-for-sale-buy" element={<BuySellBusinessServices />} />
           <Route path="/skilled-employee-services" element={<SkilledEmployeeHiringServices />} />
           <Route path="/third-party-business-services" element={<ThirdPartyBusinessServices />} />
           <Route path="/services" element={<ServiceList />} />
          
        <Route path="/plan" element={<Plan />} />
        <Route path="/faqs" element={<Faq />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/user-details/:userId" element={<UserDetails />} />
        <Route path="/video" element={<Video />} />
        {/* <Route path="/career" element={<Career />} /> */}
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
        <Route path="/termscondition" element={<Termscondition />} />
        <Route path="/refundpolicy" element={<RefundPolicy />} />
        <Route path="/teammember" element={<TeamMember />} />
          <Route path="/check-status" element={<CheckStatus />} />
         
        <Route path="/forgot-password" element={<ForgotPassword />} />
<Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/pay-now" element={<PayNow />} />
        {/* Unified User Dashboard Route */}
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={['Partner', 'Business', '3rd Party Services', 'Employee']}>
            <UserDashboard />
          </ProtectedRoute>
        } />

        {/* Admin Routes */}
        <Route path="/admin" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="categories" element={<CategoryManagement />} />
          <Route path="users/pending" element={<UserPendingManagement />} />
          <Route path="users/suspending" element={<UserSuspending />} />
          <Route path="content" element={<ContentManagement />} />
          <Route path="plans" element={<PlanManagement />} />
            <Route path="submit-enqueries" element={<AdminEnqueries />} /> 
          <Route path="home" element={<HomeManagement />} />
          <Route path="about" element={<AboutManagement />} />
          <Route path="subscribed-users" element={<SubscribedUserManagement />} />
          <Route path="business/partners" element={<PartnersEnquiries />} />
          <Route path="business/services" element={<ServicesEnquiries />} />
          <Route path="business/skilled" element={<SkilledEnquiries />} />
          <Route path="business/franchisee" element={<FranchiseeEnquiries />} />
          <Route path="business" element={<BusinessEnquiries />} />
          <Route path="business/third-party" element={<ThirdPartyEnquiries />} />
          <Route path="subscribers" element={<SubscriberManagement />} />
          <Route path="career" element={<CareerManagement />} />
          <Route path="services" element={<ServiceManagement />} />
          <Route path="blog" element={<BlogManagement />} />
          <Route path="blog/taxonomy" element={<BlogTaxonomy />} />
          <Route path="seo-settings" element={<SeoSettings />} />
          <Route path="redirects" element={<RedirectManager />} />
        </Route>

        {/* Remove individual role-based dashboard routes */}
        {/* <Route path="/partner/dashboard" element={...} /> */}
        {/* <Route path="/business/dashboard" element={...} /> */}
        {/* <Route path="/service-provider/dashboard" element={...} /> */}
        {/* <Route path="/professional/dashboard" element={...} /> */}

        {/* Dynamic Service pages: /:slug - must stay LAST among public GET
            routes so it never shadows a more specific path above. Any slug
            that doesn't match a published service falls through to the
            service-not-found state inside ServiceDetail, and any path that
            doesn't match this pattern at all (e.g. containing another
            segment) falls through to the 404 route below. */}
        <Route path="/:slug" element={<ServiceDetail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>
    </Router>
  );
};

export default App;